import {
  AlertOctagon,
  AlertTriangle,
  CheckCircle2,
  Info,
  Octagon,
} from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastAction,
  ToastProvider,
  ToastViewport,
} from "@/components/ui/toast";

const iconByTone = {
  info: <Info className="h-5 w-5" />,
  success: <CheckCircle2 className="h-5 w-5" />,
  warning: <AlertTriangle className="h-5 w-5" />,
  error: <AlertOctagon className="h-5 w-5" />,
  critical: <Octagon className="h-5 w-5" />,
} as const;

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider swipeDirection="right">
      {toasts.map((toast) => {
        const icon = toast.icon ?? iconByTone[toast.tone];
        const actionSlot = toast.action ? (
          <ToastAction
            altText={toast.action.altText ?? toast.action.label}
            onClick={() => {
              toast.action?.onClick();
              dismiss(toast.id);
            }}
          >
            {toast.action.label}
          </ToastAction>
        ) : null;

        return (
          <Toast
            key={toast.id}
            open={toast.open}
            tone={toast.tone}
            icon={icon}
            title={toast.title}
            description={toast.description}
            dismissible={toast.dismissible}
            actionSlot={actionSlot}
            progress={toast.progress}
            autoProgress={toast.autoDismiss && toast.progress === null}
            durationMs={toast.durationMs}
            onDismiss={() => {
              dismiss(toast.id);
              toast.onDismiss?.();
            }}
          />
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
